import Parse from "parse";

type OD3_Tenant = Parse.Object;

export interface AgencyAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  agency_email?: string;
  agency_fare_url?: string;
  agency_id: string;
  agency_lang?: string;
  agency_name: string;
  agency_phone?: string;
  agency_timezone: string;
  agency_url: string;
  tenant: OD3_Tenant;
}

export class Agency extends Parse.Object<AgencyAttributes> {
  static className: string = "OD3_GTFS_Agency";

  constructor(data?: Partial<AgencyAttributes>) {
    super("OD3_GTFS_Agency", data as AgencyAttributes);
  }

  get agency_email(): string | undefined {
    return super.get("agency_email");
  }
  set agency_email(value: string | undefined) {
    super.set("agency_email", value);
  }
  get agency_fare_url(): string | undefined {
    return super.get("agency_fare_url");
  }
  set agency_fare_url(value: string | undefined) {
    super.set("agency_fare_url", value);
  }
  get agency_id(): string {
    return super.get("agency_id");
  }
  set agency_id(value: string) {
    super.set("agency_id", value);
  }
  get agency_lang(): string | undefined {
    return super.get("agency_lang");
  }
  set agency_lang(value: string | undefined) {
    super.set("agency_lang", value);
  }
  get agency_name(): string {
    return super.get("agency_name");
  }
  set agency_name(value: string) {
    super.set("agency_name", value);
  }
  get agency_phone(): string | undefined {
    return super.get("agency_phone");
  }
  set agency_phone(value: string | undefined) {
    super.set("agency_phone", value);
  }
  get agency_timezone(): string {
    return super.get("agency_timezone");
  }
  set agency_timezone(value: string) {
    super.set("agency_timezone", value);
  }
  get agency_url(): string {
    return super.get("agency_url");
  }
  set agency_url(value: string) {
    super.set("agency_url", value);
  }
  get tenant(): OD3_Tenant {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant) {
    super.set("tenant", value);
  }
}

Parse.Object.registerSubclass("OD3_GTFS_Agency", Agency);
